/* 
  请求患者详情封装
  create by 李智惠 2021-03-16
*/
import { patientInfo, patientInfos } from "@/api/patient"; // 患者基础信息请求
import { labelList } from "@/api/operatelabel"; // 标签列表请求
import { postList } from "@/api/post"; // 科室列表请求
import { labelEdit, postEdit } from "@/api/patient"; // 患者标签请求
async function getPatientMsg() {
  let { data, code } = await patientInfo(this.patientId);
  if (code == 200) {
    this.patientForm = data;
    data.createDate = data.createTime.substr(0, 10);
    this.$computeAge(data.birthday, data);
    this.orderPatientInfo = data;
    this.$forceUpdate();
    this.$emit('getPatientForm', data);
    // 整理标签数组
    this.labelTags = [], this.labels = [], this.postTags = [], this.posts = [];
    if (data.hospLabels.length > 0) {
      data.hospLabels.forEach(item => {
        this.labelTags.push({ label: item.labelName, value: item.labelId });
        this.labels.push(item.labelId);
      });
    }
    if (data.sysPosts.length > 0) {
      data.sysPosts.forEach(item => {
        this.postTags.push({ label: item.postName, value: item.postId });
        this.posts.push(item.postId);
      });
    }
    if (this.posts.length == 0 && this.labels.length == 0) this.btnTitle = "添加标签";
    else this.btnTitle = "编辑标签";
  }
}
// 获取科室列表
async function getPostList() {
  let { code, rows, total } = await postList();
  if (code == 200 && total > 0) rows.forEach(item => {
    this.postOptions.push({ label: item.postName, value: item.postId });
  });
  this.loading = false;
}
// 获取运营标签列表
async function getLabelList() {
  let { code, rows, total } = await labelList({ type: 1 })
  if (code == 200 && total > 0) rows.forEach(item => {
    this.labelOptions.push({ label: item.labelName, value: item.labelId });
  });
}
// 保存标签编辑
function saveEdit() {
  let _this = this;
  saveLabel(_this);
}

// 保存运营标签
async function saveLabel(_this) {
  let { code } = await labelEdit({ labelIds: [..._this.labels], patientId: _this.patientId });
  if (code == 200) savePostLabel(code, _this);
}

// 保存科室标签
async function savePostLabel(labelCode, _this) {
  let { code } = await postEdit({ postIds: [..._this.posts], patientId: _this.patientId });
  if (code == 200 && labelCode == 200) {
    _this.$message.success("编辑标签成功！");
    _this.getPatientMsg();
    _this.tagVisible = false;
  }
}

// 获取患者交易信息
async function getChargeMsg() {
  let { data, code } = await patientInfos(this.patientId);
  if (code == 200) {
    if (data.price == null) data.price = 0;
    else data.price = Math.round(data.price * 100) / 100;
    if (data.outpatientValue == null) data.outpatientValue = "-";
    this.chargeMsg = data;
  }
}

export default {saveEdit, getChargeMsg, getLabelList, getPostList, getPatientMsg}